module.exports = __webpack_public_path__ + "assets/img/maintenance-banner.68360694.png";